import { faCircleCheck, faKey } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Flex } from 'components';
import { P } from 'components/Typography/Typography';
import { Button, TextField } from 'components/_form';
import { t } from 'i18next';
import { theme as themeConfig } from 'styles/theme';

import { AccordionItemButton } from 'react-accessible-accordion';
import { PasswordErrorModal } from './PasswordErrorModal';
import { PasswordHibpSync } from './PasswordHibpSync';
import { PasswordRulesHint } from './PasswordRulesHint';
import { useProfilePasswordForm } from './useProfilePasswordForm';
import {
  StyledAccordionItemHeading,
  StyledAccordionItemPanel
} from '../../../ProfileView.styled';

export const PasswordForm = () => {
  const {
    register,
    onSubmit,
    errors,
    isValid,
    passwordValue,
    passwordsMatch,
    isSubmitting,
    isErrorModalOpen,
    setIsErrorModalOpen,
    hibpRef,
    translateFieldError,
    rulesIcon,
    rulesIconColor,
    rulesTitleColor,
    rulesBodyColor
  } = useProfilePasswordForm();

  return (
    <>
      <StyledAccordionItemHeading>
        <AccordionItemButton>
          <Flex p={2}>
            <FontAwesomeIcon icon={faKey} />
            <P ml={2} variant="body">
              {t('auth.changePassword')}
            </P>
          </Flex>
        </AccordionItemButton>
      </StyledAccordionItemHeading>
      <StyledAccordionItemPanel>
        <form onSubmit={onSubmit}>
          <Flex flexDirection={['column', 'row']} mb={3}>
            <Box mr={2} mb={[2, 0]} width="100%">
              <TextField
                label="auth.password"
                type="password"
                {...register('password')}
                error={translateFieldError(errors.password?.message)}
              />
            </Box>
            <Box width="100%">
              <TextField
                label="auth.passwordConfirm"
                type="password"
                {...register('password_confirmation')}
                error={translateFieldError(
                  errors.password_confirmation?.message
                )}
              />
              {passwordsMatch && (
                <Flex alignItems="center" mt={1} gap="0.5rem">
                  <FontAwesomeIcon
                    icon={faCircleCheck}
                    color={themeConfig.palette.accent.green}
                    style={{ flexShrink: 0 }}
                  />
                  <P variant="body" color="green">
                    {t('auth.passMatchOk')}
                  </P>
                </Flex>
              )}
            </Box>
          </Flex>

          <Flex
            mt={2}
            pt={3}
            justifyContent="space-between"
            alignItems={['flex-start', 'flex-end']}
            flexDirection={['column', 'row']}
            gap="1rem"
          >
            <PasswordRulesHint
              rulesIcon={rulesIcon}
              rulesIconColor={rulesIconColor}
              rulesTitleColor={rulesTitleColor}
              rulesBodyColor={rulesBodyColor}
            />
            <Button
              type="submit"
              disabled={!isValid || isSubmitting}
              variant="green"
            >
              {t('common.save')}
            </Button>
          </Flex>
        </form>
      </StyledAccordionItemPanel>
      <PasswordErrorModal
        isModalOpen={isErrorModalOpen}
        setIsModalOpen={setIsErrorModalOpen}
      />

      <PasswordHibpSync password={passwordValue} hibpRef={hibpRef} />
    </>
  );
};
